import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { useAblyRealtime } from 'hb-react/shared/hooks/useSubscribeToAblyChannel/hooks/useAblyRealtime';

const useVirusScanningEnabled = () => {
  const { flagEvVirusScanning } = useFeatureFlag();

  const { isAblyEnabled } = useAblyRealtime();

  const virusScanningEnabled = flagEvVirusScanning && isAblyEnabled;

  return virusScanningEnabled;
};

export default useVirusScanningEnabled;
